export interface IBrandSet {
  ValamarPlaces: string;
  ValamarCollection: string;
  ValamarCampingAdriatic: string;
  ValamarHotelsAndResorts: string;
  ValamarSunny: string;
}

export function getBrands(env: string): IBrandSet {
  return {
    ValamarPlaces: "Places by Valamar",
    ValamarCollection: "Valamar Collection",
    ValamarCampingAdriatic:
      env === 'prod'
        ? "Valamar Camping"
        : "Camping Adriatic by Valamar",
    ValamarHotelsAndResorts: "Valamar Hotels & Resorts",
    ValamarSunny: "Sunny by Valamar"
  };
}
